import { type AnyRoute, createRouter } from '@tanstack/react-router'
import * as TanstackQuery from '../integrations/tanstack-query/root-provider'

/**
 * Factory that creates the application router.
 * Encapsulates shared defaults and context wiring.
 */
export function createAppRouter(routeTree: AnyRoute) {
	return createRouter({
		routeTree,
		context: {
			auth: undefined,
			// biome-ignore lint/style/noNonNullAssertion: We use non-null assertion here because in tests we often don't need the full context, and this allows us to avoid having to provide it.
			config: undefined!,
			// biome-ignore lint/style/noNonNullAssertion: Ability is injected at runtime through RouterProvider context.
			ability: undefined!,
			// biome-ignore lint/style/noNonNullAssertion: Session user is injected at runtime through RouterProvider context.
			userSession: undefined!,
			...TanstackQuery.getContext(),
		},

		// wandering users cause too many requests to the server, so we disable it for now
		// also: intent based preload makes no sense if caching stale time is 0
		defaultPreload: false,

		scrollRestoration: true,
		defaultStructuralSharing: true,
	})
}

// Re-export type augmentation helper so consumer can call in main once
export type AppRouter = ReturnType<typeof createAppRouter>
